import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { extractError } from "../lib/formatError";
import { AuthShell } from "./Signup";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [status, setStatus] = useState("verifying"); // verifying | ok | error
  const [error, setError] = useState(null);
  const didRunRef = useRef(false);

  useEffect(() => {
    if (didRunRef.current) return; // StrictMode double-invoke guard
    didRunRef.current = true;
    const token = params.get("token");
    if (!token) {
      setStatus("error");
      setError("Missing verification token");
      return;
    }
    (async () => {
      try {
        await api.post("/auth/verify-email", { token });
        setStatus("ok");
        setTimeout(() => nav("/login", { replace: true }), 2000);
      } catch (e) {
        setError(extractError(e));
        setStatus("error");
      }
    })();
  }, [params, nav]);

  return (
    <AuthShell title="Verify your email" subtitle="Confirming your account" testid="verify-email-page">
      {status === "verifying" && (
        <div className="text-sm text-[color:var(--muted)]" data-testid="verify-status-verifying">
          Verifying your email…
        </div>
      )}
      {status === "ok" && (
        <div data-testid="verify-status-ok">
          <div className="text-[color:var(--gold)] font-display italic text-2xl mb-2">Verified.</div>
          <p className="text-sm text-[color:var(--muted)]">
            Redirecting you to log in…
          </p>
        </div>
      )}
      {status === "error" && (
        <div data-testid="verify-status-error">
          <div className="text-[color:var(--red)] font-display italic text-2xl mb-2">Verification failed.</div>
          <p className="text-xs text-[color:var(--muted)] mb-4">{error}</p>
          <Link to="/signup" className="text-xs tracking-widest uppercase text-[color:var(--gold)]">
            Start over
          </Link>
        </div>
      )}
    </AuthShell>
  );
}
